<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.memberCode ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="用户名" prop="memberNichen">
          <el-input v-model="dataForm.memberNichen" :disabled="true" placeholder="用户名"></el-input>
      </el-form-item>
          <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="dataForm.createTime" :disabled="true" placeholder="创建时间"></el-input>
      </el-form-item>
          <el-form-item label="金币数量" prop="memberCion">
          <el-input v-model="dataForm.memberCion" placeholder="金币数量"></el-input>
      </el-form-item>
          <el-form-item label="提现余额" prop="balance">
          <el-input v-model="dataForm.balance" placeholder="提现余额"></el-input>
      </el-form-item>
          <el-form-item label="账号" prop="memberName">
          <el-input v-model="dataForm.memberName" placeholder="账号" :disabled="true"></el-input>
      </el-form-item>
          <el-form-item label="用户头像" prop="memberAvatar">
          <img :src="dataForm.memberAvatar" alt="" style="width: 60px;height: 60px;">
      </el-form-item>
          <el-form-item label="密码" prop="newPassword">
          <el-input v-model="dataForm.newPassword" placeholder="密码,填了就修改了密码"></el-input>
      </el-form-item>
          <el-form-item label="VIP到期时间" prop="vipDate">
          <el-input v-model="dataForm.vipDate" :disabled="true" placeholder="VIP到期时间"></el-input>
      </el-form-item>
          <el-form-item label="微信openid" prop="wxOpenid">
          <el-input v-model="dataForm.wxOpenid" placeholder="微信openid" :disabled="true"></el-input>
      </el-form-item>
          <el-form-item label="微信Unionid" prop="wxUnionid">
          <el-input v-model="dataForm.wxUnionid" placeholder="微信Unionid" :disabled="true"></el-input>
      </el-form-item>
          <el-form-item label="上級ID" prop="pid">
          <el-input v-model="dataForm.pid" :disabled="true" placeholder="上級ID"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        memberCode: '',
        memberNichen: '',
        createTime: '',
        memberCion: '',
        balance: '',
        newPassword:'',
        memberName: '',
        memberAvatar: '',
        memberPwd: '',
        vipDate: '',
        wxOpenid: '',
        wxUnionid: '',
        pid: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        memberNichen: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        balance: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        memberName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        memberAvatar: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        memberPwd: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.memberCode) {
          this.getInfo()
          this.getVipInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/user/user/${this.dataForm.memberCode}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    //会员记录
    getVipInfo () {
      this.$http.get(`/user/user/vip/subscriptions/${this.dataForm.memberCode}`).then(({ data: res }) => {
        if (res.code === 0) {
        }else{
           return this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.memberCode ? 'post' : 'put']('/user/user/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
